meedy.controller('meedy.loginController', ['$scope', '$rootScope', '$state', '$timeout', '$cookies', '$mdDialog', 'meedy.objectHelper', 'applicationModel', 'meedy.authModel', 'meedy.userModel', '$translate', 'meedyConfig',
    function ($scope, $rootScope, $state, $timeout, $cookies, $mdDialog, objectHelper, applicationModel, authModel, userModel, $translate, config) {

        function setData() {
            userModel.currentUser = null;
            $scope.loginData = new LoginMeedyVO();
            $scope.authenticationError = false;

            $scope.selectedLanguage = $translate.use();
            if($scope.selectedLanguage === 'de_DE') {
                $scope.ueImage = 'UE_DE.jpg';
                $scope.rulesURL = 'http://www.emrplus.de/serviceordnung/';
            } else {
                $scope.ueImage = 'UE_PL.jpg';
                $scope.rulesURL = 'http://www.edmplus.pl/regulamin-serwisu-edmplus/';
            }

            $scope.forms = {
                loginForm: null
            }
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
            });

            $scope.$on(Event.MEEDY.AUTH.AUTHENTICATE_TO_CAS.SUCCESS, function (event, token) {
                authModel.authenticate($scope.loginData.login, token).then(function () {
                    authModel.authenticateMDX($scope.loginData.login, token);
                });
            });

            $scope.$on(Event.MEEDY.AUTH.AUTHENTICATE_TO_CAS.ERROR, function (event, error) {
                $scope.authenticationError = true;
            });

            $scope.$on(Event.MEEDY.AUTH.AUTHENTICATE.ERROR, function (event, error) {
                $scope.authenticationError = true;
            });

            $scope.$on(Event.MEEDY.USER.GET_LOGGED_USER.SUCCESS, function (event, error) {
                $state.go(Constant.STATE.APP.MEEDY.HOME);
            });

            $scope.$on(Event.MEEDY.USER.GET_LOGGED_USER.ERROR, function (event, error) {
                $cookies.remove('meedy_access_token');
                $cookies.remove('meedy_refresh_token');
                $cookies.remove('edm-cookie');
            });
        }

        function setActions() {
            $scope.login = function() {
                userModel.selectedLanguage = $scope.selectedLanguage;
                localStorage.setItem('meedy_lang', $scope.selectedLanguage);
                $scope.forms.loginForm.$setSubmitted();

                if ($scope.forms.loginForm.$valid) {
                    authModel.authenticateToCAS($scope.loginData.login, $scope.loginData.password);
                }
                else {
                    $scope.notifyValidationError();
                }
            };

            $scope.goToRemindPassword = function() {
                $state.go(Constant.STATE.PRE.MEEDY.REMIND_PASSWORD);
            };

            $scope.languageChanged = function () {
                $translate.use($scope.selectedLanguage);
                if($scope.selectedLanguage === 'de_DE') {
                    $scope.ueImage = 'UE_DE.jpg';
                    $scope.rulesURL = 'http://www.emrplus.de/serviceordnung/';
                } else {
                    $scope.ueImage = 'UE_PL.jpg';
                    $scope.rulesURL = 'http://www.edmplus.pl/regulamin-serwisu-edmplus/';
                }
            };
        }

        function configureInterface() {
        }

        function initialize() {
            $timeout(function(){
                applicationModel.viewReady = true;
                if($cookies.get('meedy_access_token')) {
                    $rootScope.ignoreError.push(config.API_URL + '/users/loggedUserData');
                    userModel.getLoggedUser();
                } else {
                    var ua = window.navigator.userAgent;
                    var msie = ua.indexOf("MSIE ");

                    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer, return version number
                    {
                        $mdDialog.show({
                            templateUrl: 'meedy/application/view/app/popup/popup-change-browser.html',
                            controller: 'meedy.popupChangeBrowserController',
                            hasBackdrop: true,
                            clickOutsideToClose: false,
                            escapeToClose: false
                        }).then(function () {
                        }, function (error) {
                            // nothing
                        });
                    }
                }
            },50);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
